import { createStyles } from 'antd-style'

import { pick } from '@eastcoal/common/utils/object'

import { TradeSessionDetailCard } from '../../../components/DetailCard'
import { TradeSessionDetailSkeleton } from '../../../components/DetailSkeleton'
import { TradeSessionDetailTitle } from '../../../components/DetailTitle'
import { AuctionDetailBidActionPanel } from '../components/BidActionPanel'
import { AuctionDetailBidRecordCard } from '../components/BidRecordCard'
import { AuctionDetailBidRuleCard } from '../components/BidRuleCard'
import { AuctionDetailBidStatusCard } from '../components/BidStatusCard'
import { useAuctionDetailStore } from '../Store/hooks/useStore'

const useStyles = createStyles(({ token }) => ({
  layout: {
    display: 'grid',
    gridTemplateColumns: '440px 1fr',
    gridTemplateRows: 'repeat(3, auto)',
    gridTemplateAreas: `
      "a b"
      "a c"
      "a d"
    `,
    gridGap: token.padding,
    marginBlockStart: token.margin
  }
}))

export const AuctionDetailCore = () => {
  const { detailData, detailLoading } = useAuctionDetailStore(state =>
    pick(state, ['detailData', 'detailLoading'])
  )

  const {
    bizType,
    title,
    description,
    pictureIds,
    quotaContent,
    quotaEntities
  } = detailData

  const { styles } = useStyles()

  return (
    <TradeSessionDetailSkeleton
      description={description}
      loading={detailLoading}
      picture={pictureIds}
      quota={quotaContent || quotaEntities}
    >
      <TradeSessionDetailCard
        title={<TradeSessionDetailTitle bizType={bizType} title={title} />}
        classNames={{
          body: styles.layout
        }}
      >
        <AuctionDetailBidRecordCard
          style={{
            gridArea: 'a'
          }}
        />
        <AuctionDetailBidStatusCard
          style={{
            gridArea: 'b'
          }}
        />
        <AuctionDetailBidActionPanel
          style={{
            gridArea: 'c'
          }}
        />
        <AuctionDetailBidRuleCard
          style={{
            gridArea: 'd'
          }}
        />
      </TradeSessionDetailCard>
    </TradeSessionDetailSkeleton>
  )
}
